export const convertPageableResponse = (response) => {
  const { totalPages, last, size, number, first, totalElements } = response;
  return {
    last,
    first,
    size,
    number,
    totalPages,
    totalElements,
  };
};
